var map = {
	"./MIBR_01.json": "258P",
	"./MIBR_02.json": "jA37",
	"./MIBR_03.json": "IrTY",
	"./MIBR_04.json": "Q/RB",
	"./MIBR_05.json": "HJ9o",
	"./MIBR_06.json": "rgpD",
	"./MIBR_07.json": "4JMf",
	"./MIBR_08.json": "8QR7",
	"./MIBR_09.json": "PrEC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DLYx";